import { render } from "./PrcTest1Create.vue?vue&type=template&id=23493ddb&scoped=true"
import script from "./PrcTest1Create.vue?vue&type=script&lang=js"
export * from "./PrcTest1Create.vue?vue&type=script&lang=js"

import "./PrcTest1Create.vue?vue&type=style&index=0&id=23493ddb&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23493ddb"]])

export default __exports__